import { SectionTitle } from './SettingsRows';

const LAUNCH = [
  { id: 'coach', title: 'Chế độ huấn luyện viên', text: 'Mặc định từ khi bật chế độ HLV' },
  { id: 'personal', title: 'Cá nhân', text: 'Trang chủ với nhật ký của bạn' },
  { id: 'last', title: 'Chế độ dùng lần cuối', text: 'Mở lại đúng nơi bạn đang dùng' },
];
const ROW = 'flex min-h-16 w-full items-center gap-3 py-2 text-left';

// "Khi mở app": where a coach's app opens (launch_mode), in coach mode's Tài khoản and the personal Settings.
export default function LaunchModeGroup({ value, onSelect }) {
  return (
    <>
      <SectionTitle>Khi mở app</SectionTitle>
      <div role="radiogroup" aria-label="Khi mở app" className="divide-y divide-line rounded-[20px] bg-base-100 px-4">
        {LAUNCH.map((o) => (
          <button key={o.id} type="button" role="radio" aria-checked={value === o.id} className={ROW} onClick={() => onSelect(o.id)}>
            <span className={`grid size-5 shrink-0 place-items-center rounded-full border-2 ${value === o.id ? 'border-[#17804f]' : 'border-line'}`}>
              {value === o.id && <span className="size-2.5 rounded-full bg-[#17804f]" />}
            </span>
            <span>
              <span className="block text-[15px] font-semibold">{o.title}</span>
              <span className="block text-xs text-muted">{o.text}</span>
            </span>
          </button>
        ))}
      </div>
    </>
  );
}
